export default __webpack_public_path__ + "3613f35ccea4667be69dab207b983378.svg";